'use strict';

import { logger } from "../logger/index.js";
export function dispatchCommand() {
  logger.warn('dispatchCommand() is not supported on web.');
}
//# sourceMappingURL=dispatchCommand.web.js.map